import { render } from "./progress-button.component.vue?vue&type=template&id=286b90bc&ts=true"
import script from "./progress-button.component.vue?vue&type=script&lang=ts"
export * from "./progress-button.component.vue?vue&type=script&lang=ts"

import "./progress-button.component.vue?vue&type=style&index=0&id=286b90bc&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__